import { CoreMenu } from "@core/types";

export const menu: CoreMenu[] = [
  /*=============================================
=            Home Section            =
=============================================*/
  {
    id: "Home",
    title: "Home",
    type: "section",
    icon: "circle",
  },
  {
    id: "statistics",
    title: "Dashboards",
    type: "collapsible",
    icon: "home",
    children: [
      {
        id: "statistics",
        title: "Analytics",
        type: "item",
        icon: "circle",
        url: "analytics",
      },
    ],
  },

  /*=====  End of Home Section  ======*/

  /*=============================================
=            All users and activities section            =
=============================================*/
  {
    id: "statistics",
    title: "All Users & Activities",
    type: "section",
    icon: "circle",
    url: "guardians",
  },

  {
    id: "activities",
    title: "Activities",
    type: "collapsible",
    icon: "activity",
    children: [
      {
        id: "go-service",
        title: "Go Service",
        type: "collapsible",
        icon: "circle",
        children: [
          {
            id: "services",
            title: "Services & Program List",

            type: "item",
            icon: "circle",
            url: "go-service/services",
          },
          {
            id: "topServiceProviders",
            title: "Top Services Providers ",
            type: "item",
            icon: "circle",
            url: "go-service/top-providers",
          },
        ],
      },

      {
        id: "statisticss",
        title: "Posts",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "collapsible",
        icon: "file",
        // url: 'entities',
        // role: ["merchant" , "superAdmin" ]

        children: [
          {
            id: "statistics",
            title: "Posts",
            // translate: 'MENU.DASHBOARD.Statistics',

            type: "item",
            icon: "circle",
            url: "posts/posts",
            // role: ["merchant" , "superAdmin" ]
          },
          {
            id: "statistics",
            title: "Reported Posts",
            // translate: 'MENU.DASHBOARD.Statistics',

            type: "item",
            icon: "circle",
            url: "posts/reported-posts",
            // role: ["merchant" , "superAdmin" ]
          },
        ],
      },

      {
        id: "challenges",
        title: "Challenges",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "award",
        url: "posts/challenges",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },
  {
    id: "hire",
    title: "Hire",
    type: "collapsible",
    icon: "briefcase",
    children: [
      {
        id: "hire-jobs",
        title: "Jobs",
        type: "item",
        icon: "circle",
        url: "go-hire/jobs",
      },
    ],
  },

  {
    id: "statistics",
    title: "Query",
    type: "collapsible",
    icon: "help-circle",
    role: ["merchant"],
    children: [
      {
        id: "statistics",
        title: "Ask AI",
        type: "item",
        icon: "circle",
        url: "ask-ai",
        role: ["merchant"],
      },
    ],
  },
  {
    id: "statistics",
    title: "Users",
    type: "collapsible",
    icon: "users",
    children: [
      {
        id: "statistics",
        title: "All Users",
        type: "item",
        icon: "circle",
        url: "users/users-list",
      },
    ],
  },
  {
    id: "statistics",
    title: "All Persona",
    type: "collapsible",
    icon: "database",
    children: [
      {
        id: "statistics",
        title: "Players",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "users/players",
        // role: ["merchant" , "superAdmin" ]
      },

      {
        id: "statistics",
        title: "Guardians",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "users/guardians",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "statistics",
        title: "Scouts",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "users/scouts",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "statistics",
        title: "Agents",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "users/agents",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "statistics",
        title: "Coaches",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "users/coaches",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "other-users",
        title: "Other Users",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "users/other-users",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },

  {
    id: "statistics",
    title: " Admin",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "user-check",
    url: "users/admin",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "verification",
    title: "Verification",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "item",
    icon: "check-circle",
    url: "verification",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "statisticssss",
    title: "Notifications",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "server",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "statistics",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "notifications",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "statistics",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "notify",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },

  /*=====  End of All users and activities section  ======*/

  /*=============================================
=            Privileges             =
=============================================*/
  {
    id: "privileges",
    title: "Privileges",
    type: "section",
    icon: "circle",
    url: "guardians",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "privileges",
    title: "Privileges",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "item",
    icon: "circle",
    url: "privileges/user-privileges",
    // role: ["merchant" , "superAdmin" ]
  },
  {
    id: "departments",
    title: "Departments",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "circle",
    children: [
      {
        id: "departments",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/departments",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "departments",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/add-department",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
    // role: ["merchant" , "srAdmin" ]
  },

  {
    id: "roles",
    title: "Roles",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "circle",
    children: [
      {
        id: "roles",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/roles",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "roles",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/add-role",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
    // role: ["merchant" , "superAdmin" ]
  },
  {
    id: "tabs",
    title: "Tabs",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "circle",
    children: [
      {
        id: "tabs",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/tabs",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "tabs",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/add-tab",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "actions",
    title: "actions",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "circle",
    children: [
      {
        id: "actions",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/actions",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "actions",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "privileges/add-action",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
    // role: ["merchant" , "superAdmin" ]
  },

  /*=====  End of Privileges   ======*/

  /*=============================================
=            Gino Section            =
=============================================*/
  {
    id: "gino",
    title: "Gino",
    type: "section",
    icon: "circle",
  },

  {
    id: "gino",
    title: "Gino",

    type: "collapsible",
    icon: "circle",

    children: [
      {
        id: "gino",
        title: "Gino packages",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "gino/gino-packages",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "gino",
        title: "Add Package",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "item",
        icon: "circle",
        url: "gino/add-gino-package",
      },
    ],
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "gino-finance",
    title: "Gino Finance",
    type: "item",
    icon: "dollar-sign",
    url: "gino/gino-subscribers",
  },

  /*=====  End of Gino Section  ======*/

  /*=============================================
=            Sports Entities            =
=============================================*/
  {
    id: "sport-entities",
    title: "Sport Entities",
    type: "section",
    icon: "circle",
  },

  {
    id: "statistics",
    title: " Clubs",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "users",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      //      {
      //   id: "statistics",
      //   title: "Group Ages",
      //   // translate: 'MENU.DASHBOARD.Statistics',
      //   type: "collapsible",
      //   icon: "package",
      //   // url: 'entities',
      //   // role: ["merchant" , "superAdmin" ]

      //   children: [
      //     {
      //       id: "statistics",
      //       title: "List",
      //       // translate: 'MENU.DASHBOARD.Statistics',

      //       type: "item",
      //       icon: "circle",
      //       url: "sports-entities/group-ages",
      //       // role: ["merchant" , "superAdmin" ]
      //     },
      //     {
      //       id: "statistics",
      //       title: "Add",
      //       // translate: 'MENU.DASHBOARD.Statistics',

      //       type: "item",
      //       icon: "circle",
      //       url: "sports-entities/add-group-ages",
      //       // role: ["merchant" , "superAdmin" ]
      //     },
      //   ],
      // },

      {
        id: "statistics",
        title: " Sports",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "collapsible",
        icon: "activity",
        // url: 'entities',
        // role: ["merchant" , "superAdmin" ]

        children: [
          {
            id: "statistics",
            title: "List",
            // translate: 'MENU.DASHBOARD.Statistics',

            type: "item",
            icon: "circle",
            url: "sports-entities/sports",
            // role: ["merchant" , "superAdmin" ]
          },
          {
            id: "statistics",
            title: "Add",
            // translate: 'MENU.DASHBOARD.Statistics',

            type: "item",
            icon: "circle",
            url: "sports-entities/add-sports",
            // role: ["merchant" , "superAdmin" ]
          },
        ],
      },
      {
        id: "statistics",
        title: "Football Facilities",
        // translate: 'MENU.DASHBOARD.Statistics',
        type: "collapsible",
        icon: "target",
        // url: 'entities',
        // role: ["merchant" , "superAdmin" ]

        children: [
          {
            id: "statistics",
            title: "List",
            // translate: 'MENU.DASHBOARD.Statistics',

            type: "item",
            icon: "circle",
            url: "sports-entities/football-facilities",
            // role: ["merchant" , "superAdmin" ]
          },
          {
            id: "statistics",
            title: "Add",
            // translate: 'MENU.DASHBOARD.Statistics',

            type: "item",
            icon: "circle",
            url: "sports-entities/add-football-facilities",
            // role: ["merchant" , "superAdmin" ]
          },
        ],
      },
    ],
  },

  {
    id: "statistics",
    title: "Entities",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "bar-chart-2",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "statistics",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "sports-entities/entities-list",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "statistics",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "sports-entities/add-entity",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },

  //       {
  //   id: "statistics",
  //   title: "Football Entities",
  //   // translate: 'MENU.DASHBOARD.Statistics',
  //   type: "item",
  //   icon: "map",
  //   url: "sports-entities/football-entities",
  //   // role: ["merchant" , "superAdmin" ]
  // },

  /*=====  End of Sports Entities  ======*/

  /*=============================================
=            Accounting Section            =
=============================================*/
  {
    id: "accounting",
    title: "Accounting",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "section",
    icon: "circle",
    url: "guardians",
    // role: ["merchant" , "superAdmin" ]
  },
  {
    id: "contracts",
    title: "Contracts",
    //translate: "MENU.DASHBOARD.CONTRACTS",
    type: "item",
    icon: "file-text",
    url: "accounting/contracts",
  },
  {
    id: "finance",
    title: "Finance",
    //translate: "MENU.DASHBOARD.CONTRACTS",
    type: "collapsible",
    icon: "dollar-sign",
    children: [
      {
        id: "finance",
        title: "Finance",
        //translate: "MENU.DASHBOARD.CONTRACTS",
        type: "item",
        icon: "circle",
        url: "accounting/finance",
      },
      {
        id: "Refund-Requests",
        title: "Refund Requests",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "accounting/refund-requests",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },

  {
    id: "transactions",
    title: "Transactions",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "credit-card",
    url: "accounting/transactions",
    // role: ["merchant" , "superAdmin" ]
  },
  {
    id: "requested-transactions",
    title: "Requested Transactions",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "arrow-right",
    url: "accounting/requested-transactions",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "payments",
    title: "Payments",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "credit-card",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "payment-link",
        title: "Payment Link",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "accounting/payment-link",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "payment-transactions",
        title: "Payment Link Transactions",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "accounting/payment-transactions",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },

  //   {
  //   id: "Refunds",
  //   title: "Refunds",
  //   // translate: 'MENU.DASHBOARD.Statistics',
  //   type: "collapsible",
  //   icon: "corner-up-left",
  //   // url: 'entities',
  //   // role: ["merchant" , "superAdmin" ]

  //   children: [
  //   {
  //   id: "Refund-Requests",
  //   title: "Refund Requests",
  //   // translate: 'MENU.DASHBOARD.Statistics',

  //   type: "item",
  //   icon: "circle",
  //   url: "accounting/refund-requests",
  //   // role: ["merchant" , "superAdmin" ]
  // },
  //     {
  //       id: "Upload-Refund-Receipt",
  //       title: "Upload Receipt",
  //       // translate: 'MENU.DASHBOARD.Statistics',

  //       type: "item",
  //       icon: "circle",
  //       url: "accounting/upload-refund-receipt",
  //       // role: ["merchant" , "superAdmin" ]
  //     },
  //   ],
  // },

  /*=====  End of Accounting Section  ======*/

  /*=============================================
=            Wallets Section            =
=============================================*/
  {
    id: "Wallets",
    title: "Wallets",
    type: "section",
    icon: "circle",
  },

  {
    id: "wallets",
    title: "Wallets",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "dollar-sign",
    url: "accounting/wallets",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "wallets-insights",
    title: "Wallets Insights",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "pie-chart",
    url: "accounting/wallets-insights",
    // role: ["merchant" , "superAdmin" ]
  },

  /*=====  End of Wallets Section  ======*/

  /*=============================================
=            Subscription Section            =
=============================================*/
  {
    id: "subscription",
    title: "Subscriptions",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "section",
    icon: "circle",
    url: "guardians",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "subs-type",
    title: "Subscription Type",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "circle",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "list",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "subscription/sub-type",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "add",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "subscription/add-sub-type",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },
  {
    id: "subs-plans",
    title: "Subscription Plans",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "sliders",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "list",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "subscription/subscription-plan",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "add",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "subscription/add-subscription-plan",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },
  {
    id: "cancel-reasons",
    title: "cancellation reasons",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "sliders",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "list",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "subscription/cancel-reason",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "add",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "subscription/add-cancel-reason",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },
  {
    id: "subs",
    title: "Subscription",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "item",
    icon: "circle",
    url: "subscription/subscriptions",
  },

  /*=====  End of Subscription Section  ======*/

  /*=============================================
=            General Settings             =
=============================================*/
  {
    id: "statistics",
    title: "General Settings",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "section",
    icon: "circle",
    url: "guardians",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "statisticss",
    title: "Skills",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "star",
    // url: 'entities',
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "statistics",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "settings/skills",
        // role: ["merchant" , "superAdmin" ]
      },
      {
        id: "statistics",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "settings/add-skills",
        // role: ["merchant" , "superAdmin" ]
      },
    ],
  },

  {
    id: "payment-roles",
    title: "Payment Roles",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "user",
    url: "settings/payment-roles",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "statistics",
    title: "Tags",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "tag",
    url: "settings/tags",
    // role: ["merchant" , "superAdmin" ]
  },

  {
    id: "statistics",
    title: "Lists",
    // translate: 'MENU.DASHBOARD.Statistics',

    type: "item",
    icon: "list",
    url: "settings/lists",
    // role: ["merchant" , "superAdmin" ]
  },

  /*=====  End of General Settings   ======*/

  /*=============================================
=            Marketing and Engagments            =
=============================================*/
  {
    id: "Marketing and Engagement",
    title: "Marketing and Engagement",
    type: "section",
    icon: "circle",
    url: "guardians",
  },

  {
    id: "statistics",
    title: "GoReach ",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "item",
    icon: "gift",
    url: "go-reach/profile-offers",
    // role: ["merchant" , "superAdmin" ]
  },
  {
    id: "statistics",
    title: "Unit Price ",
    // translate: 'MENU.DASHBOARD.Statistics',
    type: "collapsible",
    icon: "gift",
    // role: ["merchant" , "superAdmin" ]

    children: [
      {
        id: "statistics",
        title: "List",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "go-reach/pricing-unit",
      },

      {
        id: "statistics",
        title: "Add",
        // translate: 'MENU.DASHBOARD.Statistics',

        type: "item",
        icon: "circle",
        url: "go-reach/add-pricing-unit",
      },
    ],
  },

  /*=====  End of Marketing and Engagments  ======*/
];
